import React, { useState, useEffect, useRef } from "react";
import SteppedNumberInput from "../../../Reusable/NumberInputs/SteppedNumberInput";

function ValueInput(props) {
  const [inputValue, setInputValue] = useState("");
  const [lastValidValue, setLastValidValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    const nextValue = props.value !== undefined ? String(props.value) : "";

    // Avoid stomping in-progress typing while the input is focused.
    if (document.activeElement === inputRef.current) {
      return;
    }

    setInputValue(nextValue);
    setLastValidValue(nextValue);
  }, [props.value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    // Allow transient states while typing.
    if (newValue === "" || newValue === "-" || newValue === "." || newValue === "-.") {
      setInputValue(newValue);
      return;
    }

    if (!isNaN(Number(newValue))) {
      setInputValue(newValue);
    }
  };

  const commitValue = () => {
    if (inputValue === "" || inputValue === "-" || inputValue === "." || inputValue === "-.") {
      setInputValue(lastValidValue);
      return;
    }

    let parsed = Number(inputValue);
    if (isNaN(parsed)) {
      setInputValue(lastValidValue);
      return;
    }

    if (typeof props.min === "number") parsed = Math.max(props.min, parsed);
    if (typeof props.max === "number") parsed = Math.min(props.max, parsed);

    const normalized = String(parsed);
    setInputValue(normalized);
    setLastValidValue(normalized);

    if (typeof props.handleChange === "function") {
      props.handleChange(parsed);
    }
  };

  const handleBlur = () => {
    commitValue();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      commitValue();

      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  };

  const handleFocus = () => {
    if (typeof props.onFocus === "function") {
      props.onFocus();
    }
  };

  return (
    <div className="ClippingValueInputWrapper">
      <label className="ClippingValueInputLabel" title={props.tooltip}>
        {props.title}
      </label>
      <SteppedNumberInput
        ref={inputRef}
        step={props.step ?? 1}
        max={props.max}
        min={props.min}
        className="ClippingValueInput"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
      />
    </div>
  );
}

export default ValueInput;
